import React, { useMemo } from 'react';
import { IStandardLabor } from '../../../../entities-generated/common/standard-labor';
import { ILaborCallout } from '../../../../entities-generated/common/labor-callout';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { BadgeType, IActionItemProps } from '../../../../framework/components/bwj-listing/entities';

interface ILaborListingProps {
  standardLabor?: IStandardLabor;
  labor: ILaborCallout | null;
  onAddLabor: (labor: IStandardLabor) => void;
  onEditLabor: (labor: ILaborCallout) => void;
  onRemoveLabor: (labor: ILaborCallout) => void;
}

export const LaborListing: React.FunctionComponent<ILaborListingProps> = (props) => {
  const { standardLabor, labor, onRemoveLabor } = props;
  const actions = useMemo(() => {
    const actions: IActionItemProps[] = [];
    if(standardLabor?.systemUseOnly === true) { return actions; } // cannot be removed

    !!labor && actions.push({
      icon: 'Delete',
      onClick: () => onRemoveLabor(labor),
    });
    return actions;
  }, [standardLabor, labor, onRemoveLabor]);

  const heading = labor?.description ?? standardLabor?.description ?? 'Error';
  const icon = !!labor ? 'CheckboxCompositeReversed' : 'Checkbox';
  const materials = !!labor && labor.materials.length > 0 ? `+${labor.materials.length} materials`
   : !!labor ? 'No materials' : undefined;

   const onClick = () => {
    if(!!labor) { 
      props.onEditLabor(labor);
    } else if(!!standardLabor) {
      props.onAddLabor(standardLabor);
    }
   }

  return (
    <BwjListing
      actions={actions}
      heading={heading}
      badge={{
        type: BadgeType.Icon,
        content: icon,
      }}
      footnote={materials}
      onClick={onClick}
    />
  );
};
